import { type FetchTicketResponse, FetchTicketResponsePriority } from "src/api/models";
import type { MenuItem } from "../types";

export function createPriorityMenuItem(
  ticket: FetchTicketResponse,
  handlers: {
    updateTicketPriority: (ticketId: string, priority: FetchTicketResponsePriority) => Promise<void>;
    onUpdateTicket: (ticket: FetchTicketResponse) => void;
  }
): MenuItem {
  return {
    label: "Set Priority",
    icon: "pi pi-sort-amount-up",
    items: Object.values(FetchTicketResponsePriority).map((priority) => ({
      label: priority,
      command: () => {
        if (!ticket.id) return;
        const previousPriority = ticket.priority;

        handlers.onUpdateTicket({ ...ticket, priority });

        handlers.updateTicketPriority(ticket.id, priority).catch(() => {
          handlers.onUpdateTicket({ ...ticket, priority: previousPriority });
        });
      },
    })),
  };
}
